import { connect } from 'react-redux';
import auth from 'comp/login';
import { cache } from 'utils';

const mapToProps = state => ({
  provide_status: state.fetch.auth_provide_account || cache.empty_obj,
  verify_status: state.fetch.auth_verify_account || cache.empty_obj
});

export default connect(mapToProps)(auth);



// WEBPACK FOOTER //
// ./src/containers/auth.js